import { NgModule } from '@angular/core';
import { UserService } from './http/user.service';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { HeaderComponent } from './header/header.component';
import { AuthenticationService } from './authentication/authentication.service';
import { DrawerService } from './services/drawer.service';
import { AuthModule } from './authentication/auth.module';
import { LeftNavComponent } from './left-nav/left-nav.component';
import { LogOutModalComponent } from '../shared/modals/log-out-modal/log-out-modal.component';
import { GlobalSimService } from './http';
import { MenuService } from './services/menu.service';
import { UserGroupService } from './http/user-group.service';
import { RolesService } from './http/roles.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SnackbarService } from './services/snack.service';
import { LoaderComponent } from './loader/loader.component';

const services = [
  UserService,
  AuthenticationService,
  DrawerService,
  GlobalSimService,
  MenuService,
  RolesService,
  UserGroupService,
  SnackbarService,
];

const angularServices = [HttpClient, HttpHandler];

const standAloneComponents = [HeaderComponent, LeftNavComponent, LogOutModalComponent, LoaderComponent];
@NgModule({
  declarations: [],
  imports: [AuthModule, HeaderComponent, MatSidenavModule, standAloneComponents],
  exports: [standAloneComponents],
  providers: [services],
})
export class CoreModule {}
